import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";

import { useUserData } from "./useUserProfile";

import { getVersionsProject } from "../api/reports/reports";
import { createErrorMessage } from "../utils/createErrorMessage";

export const useFileVersions = () => {
  const { organizationId, tenantId } = useUserData();
  const params = useParams();

  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ["getVersions", tenantId, organizationId, params.reportId],
    queryFn: async () => {
      try {
        const versionsList = await getVersionsProject(
          params.reportId!,
          organizationId,
          tenantId
        );

        return versionsList.data.data;
      } catch (error) {
        toast.error(createErrorMessage(error));
      }
    },
    enabled: !!tenantId && !!params.reportId,
  });

  return { data, isLoading, error, refetch };
};
